import React from 'react';
import styles from './Dashboard.module.scss'
import DashboardBox from "components/miscellaneous/DashboardBox/DashboardBox";
import CountryGraph from 'components/Admin/Dashboard/CountryGraph/CountryGraph';
import TreatmentsGraph from 'components/Admin/Dashboard/TreatmentsGraph/TreatmentsGraph';
import MachineConnectionsGraph from 'components/Admin/Dashboard/MachineConnectionsGraph/MachineConnectionsGraph';
import ErrorsGraph from 'components/Admin/Dashboard/ErrorsGraph/ErrorsGraph';
import TopApplicators from 'components/Admin/Dashboard/TopApplicators/TopApplicators';
import StatisticsWidget from 'components/Admin/Dashboard/StatisticsWidget/StatisticsWidget';
import DateRangeSelector from 'components/miscellaneous/DateRangeSelector/DateRangeSelector';
import moment from 'moment';

const AdminDashboard = () => {
    const [dateRange, setDateRange] = React.useState({
        startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
    });

    return (
        <div className={styles.dashboardContainer}>
            <div className={styles.container}>
                <div className={`d-flex justify-content-between ${styles.header}`}>
                    <h1 className={styles.title}>Welcome Back, Admin</h1>
                    <DateRangeSelector onChange={(data) => {
                        setDateRange(data);
                    }} />
                </div>

                <div className={styles['row']}>
                    <StatisticsWidget dateRange={dateRange} />
                </div>

                <div className={styles['row']}>
                    <div className={`${styles['component-block']} ${styles['widget-country-connections']}`}>
                        <DashboardBox header="Platform Connections by Country" info="Unique platform connections by country for the selected date range">
                            <CountryGraph dateRange={dateRange} />
                        </DashboardBox>
                    </div>
                    <div className={`${styles['component-block']} ${styles['widget-treatment-areas']}`}>
                        <DashboardBox style={{height: '100%'}} info={"Showing the 10 most popular treatment areas"} header={"Treatments by Area"}>
                            <TreatmentsGraph dateRange={dateRange} />
                        </DashboardBox>
                    </div>
                </div>

                <div className={styles['row']}>
                    <div className={`${styles['component-block']} ${styles['widget-group-bottom-left']}`}>
                        <div className={styles['row']} style={{minWidth: '50%', padding: 0}}>
                            <div className={`${styles['component-block']} ${styles['widget-errors']}`} style={{margin:0}}>
                                <DashboardBox header="Errors" info="Below pie chart shows recent platform errors by frequency" link={{title: "Service page", to: "/service"}}>
                                    <ErrorsGraph dateRange={dateRange} />
                                </DashboardBox>
                            </div>
                            <div className={`${styles['component-block']} ${styles['widget-applicators']}`} style={{margin:0}}>
                                <DashboardBox header="Top Applicators" info="Top 5 most used applicators" link={{title: 'Applicators Page', to: "/equipment/applicators"}}>
                                    <TopApplicators dateRange={dateRange} />
                                </DashboardBox>
                            </div>
                        </div>
                    </div>
                    
                    <div className={`${styles['component-block']} ${styles['widget-machine-connections']}`}>
                        <DashboardBox style={{height: '100%'}} contentStyle={{padding:0}} header={"Platform Connections"} info="Unique platform connections for the selected date range" link={{title: "Platforms", to: "/equipment/platforms"}}>
                            <MachineConnectionsGraph dateRange={dateRange} />
                        </DashboardBox>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminDashboard;
